export const getPersonaImgStringOfRGBNumbers = (sat: number) => {
	if (sat < 50) {
		return '198, 40, 40';
	}
	if (sat < 60) {
		return '249, 168, 37';
	}
	return '46, 125, 50';
};
